import React, { useState } from "react";

import { Card, Button, IconButton, Collapse, useMediaQuery } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import TicketHeaderSkeleton from "../TicketHeaderSkeleton";
import ArrowBackIos from "@material-ui/icons/ArrowBackIos";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import { useHistory } from "react-router-dom";
import { useModernLayout } from "../../context/ModernLayout/ModernLayoutContext";

const useStyles = makeStyles(theme => ({
	ticketHeader: {
		display: "flex",
		background: theme.palette.total,
		flex: "none",
		borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
		height: "65px",
		[theme.breakpoints.down("sm")]: {
			flexWrap: "wrap",
			height: 'auto',
			minHeight: '48px',
		},
	},
	// Container principal para mobile
	mobileHeaderWrapper: {
		display: "flex",
		flexDirection: "column",
		background: theme.palette.total,
		flex: "none",
	},
	// Header compacto para mobile
	ticketHeaderCompact: {
		display: "flex",
		alignItems: "center",
		background: theme.palette.total,
		minHeight: '48px',
		padding: '4px 8px 4px 0',
	},
	headerContent: {
		display: "flex",
		alignItems: "center",
		flex: 1,
		overflow: "hidden",
		minWidth: 0,
		width: 0, // Força o flex a respeitar o tamanho disponível
	},
	expandButton: {
		padding: 4,
		marginLeft: 4,
		border: `1px solid ${theme.palette.divider}`,
		borderRadius: 6,
		flexShrink: 0,
	},
	collapsibleContent: {
		width: '100%',
		background: theme.palette.background.default,
		borderTop: `1px solid ${theme.palette.divider}`,
		borderBottom: `1px solid ${theme.palette.divider}`,
	},
	actionButtonsContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		padding: '8px 12px',
		gap: 4,
		flexWrap: 'wrap',
	},
}));

const TicketHeader = ({ loading, children }) => {
	const classes = useStyles();
	const history = useHistory();
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
	const isModernLayout = useModernLayout();
	const [expanded, setExpanded] = useState(false);

	const handleBack = () => {
		history.push("/tickets");
	};

	const handleToggleExpand = () => {
		setExpanded(!expanded);
	};

	// Separar children em TicketInfo e TicketActionButtons
	const childrenArray = React.Children.toArray(children);

	if (loading) {
		return <TicketHeaderSkeleton />;
	}

	// No mobile E no Modern Layout, usar layout compacto e colapsável
	if (isMobile && isModernLayout) {
		return (
			<div className={classes.mobileHeaderWrapper}>
				<div className={classes.ticketHeaderCompact}>
					<IconButton color="primary" onClick={handleBack} style={{ padding: 6 }}>
						<ArrowBackIos style={{ fontSize: 18 }} />
					</IconButton>
					<div className={classes.headerContent}>
						{/* Mostrar dados do contato (TicketInfo) */}
						{childrenArray.length > 0 && childrenArray[0]}
					</div>
					<IconButton 
						className={classes.expandButton} 
						onClick={handleToggleExpand}
						size="small"
						title={expanded ? "Ocultar opções" : "Mostrar opções"}
					>
						{expanded ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
					</IconButton>
				</div>
				<Collapse in={expanded}>
					<div className={classes.collapsibleContent}>
						<div className={classes.actionButtonsContainer}>
							{/* Mostrar botões de ação quando expandido */}
							{childrenArray.length > 1 && childrenArray[1]}
						</div>
					</div>
				</Collapse>
			</div>
		);
	}

	// Desktop: layout normal
	return (
		<Card square className={classes.ticketHeader}>
			<Button color="primary" onClick={handleBack}>
				<ArrowBackIos />
			</Button>
			{children}
		</Card>
	);
};

export default TicketHeader;
